import React, { Dispatch, ReactNode, createContext, useEffect, useState } from "react";
import { Coordonates , Location} from "../components/types/types";
import Cookies from "../components/Cookies/cookies";

const unknownCoordonates: Coordonates = {
    latitude: "",
    longitude: "",
};
interface AppContextType {
    filterChoose: (string | number |[number,number])[],
    setFilterChoose : Dispatch<React.SetStateAction< (string | number |[number,number])[]>>,
    showFilterTel : boolean,
    setShowFilterTel : Dispatch<React.SetStateAction<boolean>>,
    searchFilterValue: string,
    setSearchFilterValue : Dispatch<React.SetStateAction<string>>,
    showPlat : [number,number,number],
    setShowPlat:  Dispatch<React.SetStateAction<[number,number,number]>>,
    connectionScreen : boolean,
    setConnectionScreen : Dispatch<React.SetStateAction<boolean>>,
    isLogin : number,
    setIsLogin : Dispatch<React.SetStateAction<number>>,
    mapComponent: google.maps.Map | null,
    setMapComponent: Dispatch<React.SetStateAction<google.maps.Map | null>>,
    currentHomePage: number,
    setCurrentHomePage: Dispatch<React.SetStateAction<number>>,
    name:string,
    setName: Dispatch<React.SetStateAction<string>>,
    firstName:string,
    setFirstName: Dispatch<React.SetStateAction<string>>,
    grade: number |undefined,
    setGrade: Dispatch<React.SetStateAction<number | undefined>> | undefined;
    imgProfil: string,
    setImgProfil: Dispatch<React.SetStateAction<string>>,
    idProfil:number,
    setIdProfil: Dispatch<React.SetStateAction<number>>,
    isAuthenticated:boolean,
    setIsAuthenticated: Dispatch<React.SetStateAction<boolean>>,
    idRestaurant:number,
    setIdRestaurant: Dispatch<React.SetStateAction<number>>,
    restoFav:number[],
    setRestoFav: Dispatch<React.SetStateAction<number[]>>,
    subscribe:number[],
    setSubscribe: Dispatch<React.SetStateAction<number[]>>,
    searchCity:string,
    setSearchCity: Dispatch<React.SetStateAction<string>>,
    valueSearchCity:string,
    setValueSearchCity: Dispatch<React.SetStateAction<string>>,
    coordonates:Coordonates,
    setCoordonates: Dispatch<React.SetStateAction<Coordonates>>,
    searchValueHome:string,
    setSearchValueHome: Dispatch<React.SetStateAction<string>>,
    showMap:boolean,
    setShowMap:Dispatch<React.SetStateAction<boolean>>,
    scriptLoad:boolean,
    setScriptLoad:Dispatch<React.SetStateAction<boolean>>,
    date_selected:Date|null,
    setDate_selected:Dispatch<React.SetStateAction<Date|null>>,
    hour_selected:string,
    setHour_selected:Dispatch<React.SetStateAction<string>>,
    isPublished:boolean,
    setIsPublished:Dispatch<React.SetStateAction<boolean>>,
    allPresentFilter:string[]
    setAllPresentFilter:Dispatch<React.SetStateAction<string[]>>,
    email:string
    setEmail:Dispatch<React.SetStateAction<string>>,
    genre:string
    setGenre:Dispatch<React.SetStateAction<string>>,
    newsLetter:boolean,
    setNewsLetter:Dispatch<React.SetStateAction<boolean>>,
    biography:string,
    setBiography:Dispatch<React.SetStateAction<string>>,
    loadPage:boolean,
    setLoadPage:Dispatch<React.SetStateAction<boolean>>,
    nameResto:string,
    setNameResto:Dispatch<React.SetStateAction<string>>,
    showCookies:boolean,
    setShowCookies:Dispatch<React.SetStateAction<boolean>>,
    locations:Location[],
    setLocations:Dispatch<React.SetStateAction<Location[]>>,
    preferencesCookies:boolean,
    setPreferencesCookies:Dispatch<React.SetStateAction<boolean>>,
    restoPhoneClicks:string[],
    setRestoPhoneClicks:Dispatch<React.SetStateAction<string[]>>,
    verifyEmail:boolean,
    setVerifyEmail:Dispatch<React.SetStateAction<boolean>>,
}

const AppContext = createContext<AppContextType>({
    filterChoose: [],
    setFilterChoose: () => {},
    showFilterTel: false,
    setShowFilterTel: () => {},
    searchFilterValue: "",
    setSearchFilterValue: () => {},
    showPlat: [-1,0,0],
    setShowPlat: () => {},
    connectionScreen:false,
    setConnectionScreen: () => {},
    isLogin: 0,
    setIsLogin: () => {},
    mapComponent: null,
    setMapComponent: () => {},
    currentHomePage: 1,
    setCurrentHomePage: () => {},
    imgProfil : "",
    setImgProfil: () => '',
    name:'',
    setName:() => {},
    firstName:'',
    setFirstName:() => {},
    grade: 0 ,
    setGrade: () => {},
    idProfil:0,
    setIdProfil:() => {},
    isAuthenticated:false,
    setIsAuthenticated: () => {},
    idRestaurant:0,
    setIdRestaurant: () => {},
    restoFav:[],
    setRestoFav:() => {},
    subscribe:[],
    setSubscribe: () => {},
    searchCity:"",
    setSearchCity:() => {},
    valueSearchCity: "",
    setValueSearchCity: () => {},
    coordonates:unknownCoordonates,
    setCoordonates:() => {},
    searchValueHome:"",
    setSearchValueHome:() => {},
    showMap:false,
    setShowMap:() => {},
    scriptLoad:false,
    setScriptLoad:() => {},
    date_selected:null,
    setDate_selected: () => {},
    hour_selected:"",
    setHour_selected:() => {},
    isPublished:false,
    setIsPublished:() => {},
    allPresentFilter:[],
    setAllPresentFilter: () => {},
    email:'',
    setEmail:() => {},
    genre:'',
    setGenre:() => {},
    newsLetter:false,
    setNewsLetter:() => {},
    biography:'',
    setBiography:() => {},
    loadPage:false,
    setLoadPage:() => {},
    nameResto:"",
    setNameResto:() => {},
    showCookies:false,
    setShowCookies:() => {},
    locations:[],
    setLocations:() => {},
    preferencesCookies:false,
    setPreferencesCookies:() => {},
    restoPhoneClicks:[],
    setRestoPhoneClicks:() => {},
    verifyEmail:true,
    setVerifyEmail:() => {},
})

interface AppContextProviderProps {
    children: ReactNode
}


const AppContextProvider = ({children}: AppContextProviderProps) => {
    const [filterChoose, setFilterChoose] = useState<(string | number |[number,number])[]>([])
    const [showFilterTel, setShowFilterTel] = useState(false)
    const [searchFilterValue, setSearchFilterValue] = useState<string>("")
    const [showPlat,setShowPlat] = useState<[number,number,number]>([-1,0,0])
    const [locations,setLocations]= useState<Location[]>([])
    const [connectionScreen,setConnectionScreen] = useState<boolean>(false)
    const [preferencesCookies,setPreferencesCookies] = useState(false)
    const [verifyEmail,setVerifyEmail] = useState(true)

    const [isLogin, setIsLogin] = useState(0)
    
    const [name, setName] = useState<string>("")
    const [firstName, setFirstName] = useState<string>("")
    const [biography,setBiography]= useState<string>("")
    const [grade, setGrade] = useState<number | undefined>(0);
    const [idProfil, setIdProfil] = useState<number>(0)
    const [imgProfil, setImgProfil] = useState<string>('')
    const [idRestaurant,setIdRestaurant] = useState<number>(-1)
    const [mapComponent, setMapComponent] = useState<google.maps.Map | null>(null)
    const [restoFav,setRestoFav] = useState<number[]>([])
    const [subscribe,setSubscribe] = useState<number[]>([])
    const [currentHomePage,setCurrentHomePage] = useState(1)

    const [searchValueHome, setSearchValueHome] = useState("")
    const [searchCity,setSearchCity] = useState<string>("")
    const [valueSearchCity,setValueSearchCity] = useState<string>("")
    const [coordonates,setCoordonates] = useState<Coordonates>(unknownCoordonates)

    const [showMap,setShowMap] = useState(false)
    const [scriptLoad,setScriptLoad]= useState(false)

    const [date_selected,setDate_selected] = useState<Date|null>(null)
    const [hour_selected,setHour_selected] = useState<string>("")
    const [isPublished,setIsPublished] = useState<boolean>(false)

    const [allPresentFilter,setAllPresentFilter]= useState<string[]>([])
    const [email,setEmail] =useState<string>('')
    const [genre,setGenre] = useState<string>('')


    const [newsLetter,setNewsLetter]= useState(false)
    const [loadPage,setLoadPage] = useState(false)
    const [nameResto,setNameResto] = useState("")
    const [restoPhoneClicks,setRestoPhoneClicks] = useState<string[]>([])

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [showCookies,setShowCookies]=useState(false)
    
    useEffect(() => {
        const authenticateUser = async () => {
          const token = localStorage.getItem('token');
          
          if (!token) {
              setIsAuthenticated(false);
              return;
          }

          try {
              const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/tokenUser`, {
                  method: 'POST',
                  credentials: 'include',
              });

              if (response.ok) {
                  const data = await response.json();
                  localStorage.setItem('token', data.accessToken);

                  const userInfoResponse = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/infoUser`, {
                      method: 'GET',
                      credentials: 'include',
                  });
                
                  if (userInfoResponse.ok) {
                      const userInfo = await userInfoResponse.json();
                      if(userInfo.success) {
                        setIsLogin(1);
                        setIsAuthenticated(true);
                        setIdProfil(userInfo.userInfo.id);
                        setName(userInfo.userInfo.name);
                        setFirstName(userInfo.userInfo.firstname)
                        setBiography(userInfo.userInfo.biography)
                        setImgProfil(userInfo.userInfo.photo);
                        setRestoFav(userInfo.userInfo.restofav)
                        setSubscribe(userInfo.userInfo.subscribe)
                        setEmail(userInfo.userInfo.email)
                        setGenre(userInfo.userInfo.genre)
                        setNewsLetter(userInfo.userInfo.newsletter)
                        setVerifyEmail(userInfo.userInfo.email_verified)
                      } else {
                        throw new Error("Erreur d'authentification");
                      }
                  }
              } 
          } catch (error) {
              try {
                  const restauResponse = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/tokenRestau`, {
                      method: 'POST',
                      credentials: 'include',
                  });
                  if (restauResponse.ok) {
                      const data = await restauResponse.json();
                      localStorage.setItem('token', data.accessToken);
                      const restauInfoResponse = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/infoRestau`, {
                          method: 'GET',
                          credentials: 'include',
                      });
                      if (restauInfoResponse.ok) {
                        const restauInfo = await restauInfoResponse.json();
                        if(restauInfo.success) {
                            setIsLogin(2);
                            setIsAuthenticated(true);
                            setIdProfil(restauInfo.restauInfo.idr);
                            setName(restauInfo.restauInfo.name);
                            setImgProfil(restauInfo.restauInfo.photo);
                            setIdRestaurant(restauInfo.restauInfo.idrestaurant);
                            setIsPublished(restauInfo.restauInfo.published)
                            setNewsLetter(restauInfo.restauInfo.newsletter)
                            setFirstName(restauInfo.restauInfo.firstname)
                            setBiography(restauInfo.restauInfo.biography)
                            setNameResto(restauInfo.restauInfo.nameresto)
                        }  else {
                            setIsAuthenticated(true);
                        }
                    }
                  } 
              } catch (err) {
                  setIsAuthenticated(true);
                  return;
              }
          }
        };
        if(!isAuthenticated)  authenticateUser()
        const getcookie = () => {
            const cookieConsent = document.cookie
                .split("; ")
                .find(row => row.startsWith("QUELRESTO_COOKIE="));
            if (!cookieConsent) {
                setShowCookies(true)
            }
            else {
                const cookieValue = decodeURIComponent(cookieConsent.split("=")[1]);
                const parsed = JSON.parse(cookieValue);

                const version = parsed["version"];
                if(!version || version !== '3') {
                    setShowCookies(true)
                    return;
                }

                const hasAnalyticsConsent = parsed["perform-analytics"];
                const hasPerformsConsent = parsed["preferences"];
                const hasMeasurement = parsed["measurement"];
                const existingScript = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
                const IS_PROD_FR = window.location.hostname.includes('quelresto.fr');
                const NEEDS_GTAG  = hasAnalyticsConsent || (hasMeasurement && IS_PROD_FR);

                if (NEEDS_GTAG && !existingScript) {
                    const inline = document.createElement('script');
                    
                    inline.id = 'gtag-init';
                    inline.innerHTML = `
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        

                        gtag('consent', 'default', {
                            ad_storage: 'denied',
                            analytics_storage: 'denied',
                            ad_user_data: 'denied',
                            ad_personalization: 'denied'
                        });

                        gtag('js', new Date());
                    `;
                    document.head.appendChild(inline);
                    const script = document.createElement('script');
                    script.src = `https://www.googletagmanager.com/gtag/js?id=G-${process.env.REACT_APP_TAG_ANALYSE}`;
                    script.async = true;
                    document.head.appendChild(script);
                }
                if (NEEDS_GTAG && typeof window.gtag === 'function') {
                    if (hasAnalyticsConsent) {
                        window.gtag('consent', 'update', { 'analytics_storage': 'granted' });
                        window.gtag('config', `G-${process.env.REACT_APP_TAG_ANALYSE}`);
                    }
                    if (hasMeasurement && IS_PROD_FR) {
                        window.gtag('consent', 'update', {
                            ad_storage: 'granted',
                            ad_user_data: 'granted'
                        });
                        window.gtag('config', `${process.env.REACT_APP_TAG_ANALYSE_ADS}`);
                    }
                }
                const domain = process.env.REACT_APP_TAG_ANALYSE === process.env.REACT_APP_TAG_ANALYSE_QR
                            ? ".quelresto.fr"
                            : ".quelresto.com";
                if (!hasAnalyticsConsent) {
                    document.cookie.split(";").forEach((cookie) => {
                        const cookieName = cookie.split("=")[0].trim();
                        if (cookieName.startsWith("_ga") || cookieName === "_gid") {
                            
                            document.cookie = `${cookieName}=; Max-Age=0; path=/; domain=${domain}; Secure; SameSite=Lax`;
                        }
                    });
                }
                if(!hasAnalyticsConsent && !hasPerformsConsent && !hasMeasurement && document.cookie.includes("g_state=")) {
                    document.cookie = `g_state=; Max-Age=0; path=/; domain=${domain}; Secure; SameSite=Lax`;
                }
                if (!hasMeasurement) {
                    document.cookie.split(";").forEach((cookie) => {
                        const cookieName = cookie.split("=")[0].trim();
                        if (cookieName.startsWith("_gcl")) {
                            
                            document.cookie = `${cookieName}=; Max-Age=0; path=/; domain=${domain}; Secure; SameSite=Lax`;
                        }
                    });
                }

                if(!hasMeasurement && !hasAnalyticsConsent) {
                    if(existingScript) {
                        existingScript.remove();
                        const configScript = document.querySelector('script:not([src])');
                        if (configScript?.innerHTML.includes("gtag")) {
                        configScript.remove();
                        }
                    }
                }
            }
        }
        getcookie()


    }, []);
    
    
    
    return(
        <AppContext.Provider  value={{
            preferencesCookies,setPreferencesCookies,
                filterChoose, setFilterChoose, 
                showFilterTel, setShowFilterTel,
                searchFilterValue, setSearchFilterValue,
                showPlat,setShowPlat,
                connectionScreen,setConnectionScreen,
                isLogin,setIsLogin,

                mapComponent, setMapComponent,
                currentHomePage,setCurrentHomePage,
                imgProfil, setImgProfil,
                name,setName,
                firstName,setFirstName,
                grade,setGrade,
                idProfil,setIdProfil,
                isAuthenticated,setIsAuthenticated,
                idRestaurant,setIdRestaurant,
                restoFav,setRestoFav,
                subscribe,setSubscribe,
                searchCity,setSearchCity,
                valueSearchCity,setValueSearchCity,
                coordonates,setCoordonates,
                searchValueHome,setSearchValueHome,
                showMap,setShowMap,
                scriptLoad,setScriptLoad,
                date_selected,setDate_selected,
                hour_selected,setHour_selected,
                isPublished,setIsPublished,
                allPresentFilter,setAllPresentFilter,
                email,setEmail,
                genre,setGenre,
                newsLetter,setNewsLetter,
                biography,setBiography,
                loadPage,setLoadPage,
                nameResto,setNameResto,
                showCookies,setShowCookies,
                locations,setLocations,
                restoPhoneClicks,setRestoPhoneClicks,
                verifyEmail,setVerifyEmail,}}>

                {showCookies && <Cookies preferences={preferencesCookies}/>
                }
                {children}


        </AppContext.Provider>
    )
}

export {AppContext, AppContextProvider}